
import { useTranslation } from 'react-i18next';
import { LanguageSelector } from '../../components/common';
import {
  BarChart3, Building, FileText, Upload, ClipboardList,
  Plus, Truck, Salad, Users, CheckCircle2, FileEdit, Settings,
  ScrollText, CreditCard, DollarSign, GraduationCap, Headphones
} from 'lucide-react';

export function DevDashboardPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="absolute top-4 right-4">
        <LanguageSelector />
      </div>

      <div className="text-center max-w-4xl">
        <h1 className="text-5xl font-bold text-gray-800 mb-4">{t('app.title')}</h1>
        <p className="text-xl text-gray-600 mb-8">{t('app.tagline')}</p>

        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">HALMAS MVP</h2>
          <p className="text-gray-600 mb-6">Explore the halal certification management system</p>

          <div className="mb-6">
            <h3 className="text-lg font-semibold text-gray-700 mb-3">Company Pages</h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <a
              href="/company/dashboard"
              className="block p-4 bg-blue-50 hover:bg-blue-100 rounded-lg transition-colors text-left"
            >
              <h3 className="font-semibold text-blue-900 mb-1 flex items-center gap-2">
                <BarChart3 className="w-5 h-5" /> Dashboard
              </h3>
              <p className="text-sm text-blue-700">Overview and metrics</p>
            </a>

            <a
              href="/company/profile"
              className="block p-4 bg-blue-50 hover:bg-blue-100 rounded-lg transition-colors text-left"
            >
              <h3 className="font-semibold text-blue-900 mb-1 flex items-center gap-2">
                <Building className="w-5 h-5" /> Company Profile
              </h3>
              <p className="text-sm text-blue-700">Manage company information</p>
            </a>

            <a
              href="/company/documents"
              className="block p-4 bg-green-50 hover:bg-green-100 rounded-lg transition-colors text-left"
            >
              <h3 className="font-semibold text-green-900 mb-1 flex items-center gap-2">
                <FileText className="w-5 h-5" /> Document Vault
              </h3>
              <p className="text-sm text-green-700">Manage documents and certificates</p>
            </a>

            <a
              href="/company/documents/upload"
              className="block p-4 bg-green-50 hover:bg-green-100 rounded-lg transition-colors text-left"
            >
              <h3 className="font-semibold text-green-900 mb-1 flex items-center gap-2">
                <Upload className="w-5 h-5" /> Upload Document
              </h3>
              <p className="text-sm text-green-700">Add new documents</p>
            </a>

            <a
              href="/company/applications"
              className="block p-4 bg-purple-50 hover:bg-purple-100 rounded-lg transition-colors text-left"
            >
              <h3 className="font-semibold text-purple-900 mb-1 flex items-center gap-2">
                <ClipboardList className="w-5 h-5" /> Applications
              </h3>
              <p className="text-sm text-purple-700">Certification applications</p>
            </a>

            <a
              href="/company/applications/new"
              className="block p-4 bg-purple-50 hover:bg-purple-100 rounded-lg transition-colors text-left"
            >
              <h3 className="font-semibold text-purple-900 mb-1 flex items-center gap-2">
                <Plus className="w-5 h-5" /> New Application
              </h3>
              <p className="text-sm text-purple-700">Start new certification</p>
            </a>

            <a
              href="/company/suppliers"
              className="block p-4 bg-orange-50 hover:bg-orange-100 rounded-lg transition-colors text-left"
            >
              <h3 className="font-semibold text-orange-900 mb-1 flex items-center gap-2">
                <Truck className="w-5 h-5" /> Suppliers
              </h3>
              <p className="text-sm text-orange-700">Manage supplier network</p>
            </a>

            <a
              href="/company/suppliers/new"
              className="block p-4 bg-orange-50 hover:bg-orange-100 rounded-lg transition-colors text-left"
            >
              <h3 className="font-semibold text-orange-900 mb-1 flex items-center gap-2">
                <Plus className="w-5 h-5" /> Add Supplier
              </h3>
              <p className="text-sm text-orange-700">Register new supplier</p>
            </a>

            <a
              href="/company/ingredients"
              className="block p-4 bg-teal-50 hover:bg-teal-100 rounded-lg transition-colors text-left"
            >
              <h3 className="font-semibold text-teal-900 mb-1 flex items-center gap-2">
                <Salad className="w-5 h-5" /> Ingredients
              </h3>
              <p className="text-sm text-teal-700">Track ingredient halal status</p>
            </a>

            <a
              href="/company/training/catalog"
              className="block p-4 bg-violet-50 hover:bg-violet-100 rounded-lg transition-colors text-left"
            >
              <h3 className="font-semibold text-violet-900 mb-1 flex items-center gap-2">
                <GraduationCap className="w-5 h-5" /> Training Catalog
              </h3>
              <p className="text-sm text-violet-700">Browse halal training courses</p>
            </a>

            <a
              href="/company/training/sessions"
              className="block p-4 bg-violet-50 hover:bg-violet-100 rounded-lg transition-colors text-left"
            >
              <h3 className="font-semibold text-violet-900 mb-1 flex items-center gap-2">
                <ScrollText className="w-5 h-5" /> Training Sessions
              </h3>
              <p className="text-sm text-violet-700">View and enroll in sessions</p>
            </a>

            <a
              href="/company/training/my-training"
              className="block p-4 bg-violet-50 hover:bg-violet-100 rounded-lg transition-colors text-left"
            >
              <h3 className="font-semibold text-violet-900 mb-1 flex items-center gap-2">
                <Users className="w-5 h-5" /> My Training
              </h3>
              <p className="text-sm text-violet-700">View enrollments and certificates</p>
            </a>

            <a
              href="/company/support"
              className="block p-4 bg-violet-50 hover:bg-violet-100 rounded-lg transition-colors text-left"
            >
              <h3 className="font-semibold text-violet-900 mb-1 flex items-center gap-2">
                <Headphones className="w-5 h-5" /> Support Center
              </h3>
              <p className="text-sm text-violet-700">Get help and browse FAQs</p>
            </a>
          </div>
          </div>

          <div className="mt-8">
            <h3 className="text-lg font-semibold text-gray-700 mb-3">Consultant Pages</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <a
                href="/consultant/dashboard"
                className="block p-4 bg-indigo-50 hover:bg-indigo-100 rounded-lg transition-colors text-left"
              >
                <h3 className="font-semibold text-indigo-900 mb-1 flex items-center gap-2">
                  <BarChart3 className="w-5 h-5" /> Consultant Dashboard
                </h3>
                <p className="text-sm text-indigo-700">Consultant overview and metrics</p>
              </a>

              <a
                href="/consultant/clients"
                className="block p-4 bg-indigo-50 hover:bg-indigo-100 rounded-lg transition-colors text-left"
              >
                <h3 className="font-semibold text-indigo-900 mb-1 flex items-center gap-2">
                  <Users className="w-5 h-5" /> Client List
                </h3>
                <p className="text-sm text-indigo-700">View and manage clients</p>
              </a>
            </div>
          </div>

          <div className="mt-8">
            <h3 className="text-lg font-semibold text-gray-700 mb-3">Auditor Pages</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <a
                href="/auditor/dashboard"
                className="block p-4 bg-rose-50 hover:bg-rose-100 rounded-lg transition-colors text-left"
              >
                <h3 className="font-semibold text-rose-900 mb-1 flex items-center gap-2">
                  <BarChart3 className="w-5 h-5" /> Auditor Dashboard
                </h3>
                <p className="text-sm text-rose-700">Auditor overview and metrics</p>
              </a>

              <a
                href="/auditor/applications"
                className="block p-4 bg-rose-50 hover:bg-rose-100 rounded-lg transition-colors text-left"
              >
                <h3 className="font-semibold text-rose-900 mb-1 flex items-center gap-2">
                  <ClipboardList className="w-5 h-5" /> Application Queue
                </h3>
                <p className="text-sm text-rose-700">Review applications</p>
              </a>

              <a
                href="/auditor/audits/app-001"
                className="block p-4 bg-rose-50 hover:bg-rose-100 rounded-lg transition-colors text-left"
              >
                <h3 className="font-semibold text-rose-900 mb-1 flex items-center gap-2">
                  <CheckCircle2 className="w-5 h-5" /> Audit Checklist
                </h3>
                <p className="text-sm text-rose-700">Conduct official audits</p>
              </a>

              <a
                href="/auditor/ncr/create"
                className="block p-4 bg-rose-50 hover:bg-rose-100 rounded-lg transition-colors text-left"
              >
                <h3 className="font-semibold text-rose-900 mb-1 flex items-center gap-2">
                  <FileEdit className="w-5 h-5" /> Create NCR
                </h3>
                <p className="text-sm text-rose-700">Non-Conformance Reports</p>
              </a>
            </div>
          </div>

          <div className="mt-8">
            <h3 className="text-lg font-semibold text-gray-700 mb-3">Admin Dashboard & User Management</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <a
                href="/admin/dashboard"
                className="block p-4 bg-amber-50 hover:bg-amber-100 rounded-lg transition-colors text-left"
              >
                <h3 className="font-semibold text-amber-900 mb-1 flex items-center gap-2">
                  <BarChart3 className="w-5 h-5" /> Admin Dashboard
                </h3>
                <p className="text-sm text-amber-700">System overview and metrics</p>
              </a>

              <a
                href="/admin/users"
                className="block p-4 bg-amber-50 hover:bg-amber-100 rounded-lg transition-colors text-left"
              >
                <h3 className="font-semibold text-amber-900 mb-1 flex items-center gap-2">
                  <Users className="w-5 h-5" /> User Management
                </h3>
                <p className="text-sm text-amber-700">Manage all system users</p>
              </a>

              <a
                href="/admin/settings"
                className="block p-4 bg-amber-50 hover:bg-amber-100 rounded-lg transition-colors text-left"
              >
                <h3 className="font-semibold text-amber-900 mb-1 flex items-center gap-2">
                  <Settings className="w-5 h-5" /> System Settings
                </h3>
                <p className="text-sm text-amber-700">Configure system settings</p>
              </a>

              <a
                href="/admin/training"
                className="block p-4 bg-amber-50 hover:bg-amber-100 rounded-lg transition-colors text-left"
              >
                <h3 className="font-semibold text-amber-900 mb-1 flex items-center gap-2">
                  <GraduationCap className="w-5 h-5" /> Training Management
                </h3>
                <p className="text-sm text-amber-700">Manage courses and sessions</p>
              </a>

              <a
                href="/admin/support"
                className="block p-4 bg-amber-50 hover:bg-amber-100 rounded-lg transition-colors text-left"
              >
                <h3 className="font-semibold text-amber-900 mb-1 flex items-center gap-2">
                  <Headphones className="w-5 h-5" /> Support Center
                </h3>
                <p className="text-sm text-amber-700">Manage support tickets</p>
              </a>

              <a
                href="/admin/certificates"
                className="block p-4 bg-amber-50 hover:bg-amber-100 rounded-lg transition-colors text-left"
              >
                <h3 className="font-semibold text-amber-900 mb-1 flex items-center gap-2">
                  <ScrollText className="w-5 h-5" /> Certificate Management
                </h3>
                <p className="text-sm text-amber-700">Issue and manage certificates</p>
              </a>
            </div>
          </div>

          <div className="mt-8">
            <h3 className="text-lg font-semibold text-gray-700 mb-3">Certificate Issuance & Management</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <a
                href="/company/certificates"
                className="block p-4 bg-cyan-50 hover:bg-cyan-100 rounded-lg transition-colors text-left"
              >
                <h3 className="font-semibold text-cyan-900 mb-1 flex items-center gap-2">
                  <ScrollText className="w-5 h-5" /> My Certificates
                </h3>
                <p className="text-sm text-cyan-700">View your halal certificates</p>
              </a>

              <a
                href="/verify"
                className="block p-4 bg-cyan-50 hover:bg-cyan-100 rounded-lg transition-colors text-left"
              >
                <h3 className="font-semibold text-cyan-900 mb-1 flex items-center gap-2">
                  <CheckCircle2 className="w-5 h-5" /> Verify Certificate
                </h3>
                <p className="text-sm text-cyan-700">Public certificate verification</p>
              </a>
            </div>
          </div>

          <div className="mt-8">
            <h3 className="text-lg font-semibold text-gray-700 mb-3">Payment System</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <a
                href="/company/payments"
                className="block p-4 bg-emerald-50 hover:bg-emerald-100 rounded-lg transition-colors text-left"
              >
                <h3 className="font-semibold text-emerald-900 mb-1 flex items-center gap-2">
                  <CreditCard className="w-5 h-5" /> Payment Dashboard
                </h3>
                <p className="text-sm text-emerald-700">Manage payments and invoices</p>
              </a>

              <a
                href="/consultant/invoices"
                className="block p-4 bg-emerald-50 hover:bg-emerald-100 rounded-lg transition-colors text-left"
              >
                <h3 className="font-semibold text-emerald-900 mb-1 flex items-center gap-2">
                  <FileText className="w-5 h-5" /> Consultant Invoices
                </h3>
                <p className="text-sm text-emerald-700">Create and manage invoices</p>
              </a>

              <a
                href="/admin/payments"
                className="block p-4 bg-emerald-50 hover:bg-emerald-100 rounded-lg transition-colors text-left"
              >
                <h3 className="font-semibold text-emerald-900 mb-1 flex items-center gap-2">
                  <BarChart3 className="w-5 h-5" /> Payment Records
                </h3>
                <p className="text-sm text-emerald-700">Admin payment management</p>
              </a>

              <a
                href="/company/applications/app-001/payment"
                className="block p-4 bg-emerald-50 hover:bg-emerald-100 rounded-lg transition-colors text-left"
              >
                <h3 className="font-semibold text-emerald-900 mb-1 flex items-center gap-2">
                  <DollarSign className="w-5 h-5" /> Application Payment
                </h3>
                <p className="text-sm text-emerald-700">Pay for certification application</p>
              </a>
            </div>
          </div>
        </div>

        <p className="text-gray-500 text-sm">
          Built with React + TypeScript + Vite
        </p>
      </div>
    </div>
  );
}
